import { z } from 'zod';

export const cardStatusShema = z.object({
  doc_requested: z.boolean(),
  is_blocked_by_client: z.boolean(),
  is_blocked_by_risk: z.boolean(),
  is_first_deposit: z.boolean(),
  is_first_payout: z.boolean(),
  is_new: z.boolean(),
  is_verified: z.boolean()
});

export const cardShema = z.object({
  account_id: z.string().optional(),
  card_hash: z.string().optional(),
  card_holder_name: z.string().optional(),
  card_mask: z.string(),
  card_number: z.string().optional(),
  card_status: z.number(),
  description: z.string().optional(),
  exp_month: z.string().optional(),
  exp_year: z.string().optional(),
  partner_id: z.number().optional(),
  status: cardStatusShema,
  type: z.enum(['pan', 'wallet', 'pan_token'])
});

export const getAllCardsResponseDataShema = z.object({
  response: z.array(cardShema),
  status: z.string()
});

export const saveBankCardResponseShema = z.object({
  card_hash: z.string(),
  cashdesk: z.number(),
  creation_date: z.string(),
  currency: z.string(),
  deleted: z.number(),
  id: z.number(),
  is_active: z.string(),
  partner_id: z.number(),
  service_id: z.number(),
  status_t: z.number(),
  statuses: cardStatusShema,
  user_id: z.number(),
  ut: z.string(),
  wallet_account_id: z.string(),
  wallet_id: z.string()
});

export const putCVVToCacheResponseDataShema = z.object({
  status: z.string()
});

export const deleteBankCardResponseDataShema = z.object({
  error: z.string(),
  error_code: z.string()
});
